import { render, staticRenderFns } from "./ContasPagarLista.vue?vue&type=template&id=6bf133fe&"
import script from "./ContasPagarLista.vue?vue&type=script&lang=js&"
export * from "./ContasPagarLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports